import { m8API } from 'services/production/m8';
import { SendAuthorisationCodeOnPhoneService } from 'types/services';

export const sendAuthorisationCodeOnPhone: SendAuthorisationCodeOnPhoneService = async (
  params
) => {
  const { phone } = params;

  await m8API.auth.sendAuthorisationCodeOnPhone({ phone });
};
